import { createLogger as shellCreateLogger } from '@aviv-unified-frontend/runtime/monitoring';
export const createLogger = (name) => shellCreateLogger({ name, version: 1 });
